"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { observable, computed, action } from "mobx";
export class FolderSelectionViewStore {
  constructor(initialState) {
    this._selectedFolder = initialState;
  }
  get selectedFolder() {
    return this._selectedFolder;
  }
  setSelectedFolder(folderId) {
    this._selectedFolder = folderId;
  }
}
__decorateClass([
  observable.ref
], FolderSelectionViewStore.prototype, "_selectedFolder", 2);
__decorateClass([
  computed
], FolderSelectionViewStore.prototype, "selectedFolder", 1);
__decorateClass([
  action.bound
], FolderSelectionViewStore.prototype, "setSelectedFolder", 1);
